import { c as _c } from "react/compiler-runtime";
import { buildPhoneIsoCodeOptions } from '@module/mdrt-org/shared/utils/helpers/build-phone-iso-code-options';
import { getDefaultPhoneIsoCodeOption } from '@module/mdrt-org/shared/utils/helpers/get-default-phone-iso-code-option';
import { type PhoneNumber } from '@module/mdrt-org/shared/utils/types/customer-profile';
import { APP_PHONE_TYPE_OPTIONS, APP_PHONE_TYPES, PhoneType } from '@module/mdrt-org/shared/utils/types/phone-type';
import { useAccountSettingsPageContext } from '../../providers/account-settings-page-context';
import { type ContactInformationPhoneNumberFormDataPartial } from '../../utils/types/form-data';
const sortBySelectedPhoneNumberTypeField = (firstPhoneNumber: ContactInformationPhoneNumberFormDataPartial, secondPhoneNumber: ContactInformationPhoneNumberFormDataPartial, selectedPhoneType: Nullable<PhoneType>) => firstPhoneNumber.phoneTypeOption?.value === selectedPhoneType ? -1 : secondPhoneNumber.phoneTypeOption?.value === selectedPhoneType ? 1 : 0;
export const usePhoneSectionData = () => {
  const $ = _c(14);
  const {
    countriesData,
    customerProfileContextData
  } = useAccountSettingsPageContext();
  let defaultPhoneNumber;
  let phoneIsoCodeOptions;
  let t0;
  if ($[0] !== countriesData || $[1] !== customerProfileContextData.countryId || $[2] !== customerProfileContextData.phoneNumbers || $[3] !== customerProfileContextData.selectedPhoneType) {
    phoneIsoCodeOptions = buildPhoneIsoCodeOptions(countriesData);
    const defaultPhoneIsoCodeOption = getDefaultPhoneIsoCodeOption({
      countriesData,
      countryId: customerProfileContextData.countryId,
      phoneIsoCodeOptions
    });
    defaultPhoneNumber = {
      phoneAreaCode: "",
      phoneIsoCodeOption: defaultPhoneIsoCodeOption,
      phoneNumber: "",
      phoneTypeOption: {
        label: PhoneType.CELL_PHONE,
        value: PhoneType.CELL_PHONE
      }
    };
    const mapPhoneNumberToFormPartial = phoneItem => {
      const {
        areaCode,
        countryCode,
        phoneNumber,
        phoneType
      } = phoneItem;
      return {
        phoneAreaCode: areaCode ?? "",
        phoneIsoCodeOption: phoneIsoCodeOptions?.find(item => item?.value === countryCode) ?? null,
        phoneNumber,
        phoneTypeOption: APP_PHONE_TYPE_OPTIONS?.find(item_0 => item_0?.value === phoneType) ?? {
          label: PhoneType.CELL_PHONE,
          value: PhoneType.CELL_PHONE
        }
      };
    };
    t0 = customerProfileContextData.phoneNumbers?.filter(_temp).map(mapPhoneNumberToFormPartial).sort((firstPhoneNumber, secondPhoneNumber) => sortBySelectedPhoneNumberTypeField(firstPhoneNumber, secondPhoneNumber, customerProfileContextData.selectedPhoneType));
    $[0] = countriesData;
    $[1] = customerProfileContextData.countryId;
    $[2] = customerProfileContextData.phoneNumbers;
    $[3] = customerProfileContextData.selectedPhoneType;
    $[4] = defaultPhoneNumber;
    $[5] = phoneIsoCodeOptions;
    $[6] = t0;
  } else {
    defaultPhoneNumber = $[4];
    phoneIsoCodeOptions = $[5];
    t0 = $[6];
  }
  const initialPhoneNumbers = t0;
  let t1;
  if ($[7] !== defaultPhoneNumber || $[8] !== initialPhoneNumbers) {
    t1 = initialPhoneNumbers && initialPhoneNumbers?.length > 0 ? initialPhoneNumbers : [defaultPhoneNumber];
    $[7] = defaultPhoneNumber;
    $[8] = initialPhoneNumbers;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== defaultPhoneNumber || $[11] !== phoneIsoCodeOptions || $[12] !== t1) {
    t2 = {
      defaultPhoneNumber,
      initialPhoneNumbers: t1,
      phoneIsoCodeOptions,
      phoneTypeOptions: APP_PHONE_TYPE_OPTIONS
    };
    $[10] = defaultPhoneNumber;
    $[11] = phoneIsoCodeOptions;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
};
function _temp(item_1) {
  return APP_PHONE_TYPES.includes(item_1.phoneType as PhoneType);
}